import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

type SimpleBackdropProps = {
    open: boolean,
    zIndex?: number
}

export default function SimpleBackdrop({ open, zIndex = 1 } : SimpleBackdropProps) {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + zIndex }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}